// tslint:disable
export enum TCSTaskType {
    /**
     * @description None
     */
    None = 0,
    /**
     * @description Outbound Call
     */
    Obc = 1,
    /**
     * @description 7-Day Transition Program
     */
    TransitionProgram7Day = 2,
    /**
     * @description 10-Day Transition Program
     */
    TransitionProgram10Day = 3,
    /**
     * @description Inbound Call CAPm
     */
    IbcCapM = 4,
    /**
     * @description Inbound Call CAPa
     */
    IbcCapA = 5,
}
(TCSTaskType as any)['NONE'] = 0;
(TCSTaskType as any)['OBC'] = 1;
(TCSTaskType as any)['TRANSITIONPROGRAM7DAY'] = 2;
(TCSTaskType as any)['TRANSITIONPROGRAM10DAY'] = 3;
(TCSTaskType as any)['IBCCAPM'] = 4;
(TCSTaskType as any)['IBCCAPA'] = 5;
